/* eslint-disable react/prefer-stateless-function,react/no-unused-prop-types */
import React, { Component } from 'react';
import {
  selectItemById,
  selectItemsIds,
  sendRequest,
  changeQueryParams,
  selectRequestState,
  selectPagination,
  selectTotal
} from 'mt-react-common/common/reducers/list/reducer';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import qs from 'qs';
import _ from 'lodash';
import { t } from 'utils/translates';
import PaginationBlock from '../../../Common/Pagination/PaginationBlock/PaginationBlock';
import UserDaysStatTable2Item from './UserDaysStatTable2Item';
import DateRangeInput from '../../../Common/Inputs/DateRangeInput/DateRangeInput';
import GroupByTypesSelect from '../inputs/GroupByTypesSelect';
import OpacityPreLoader from '../../../Common/PreLoaders/OpacityPreLoader';
import SortLabelColumnToggle from '../../../Common/Inputs/SortLabelColumnToggle';

const userDaysStatListRN = 'userDaysStatModule.lists.userReferralsDaysStatList';

class UserDaysStatTable2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      queryParams: {
        page: 1,
        group_by: null,
        dateFrom: null,
        dateTo: null,
        sort: '-date'
      },
      queryParamsStatic: {}
    };
    this.state = {
      queryParams: { ...this.state.queryParams, ...props.initQueryParams }
    };
    this.sendRequest();
  }

  componentDidUpdate(prevProps) {
    if (
      !_.isEqual(
        qs.parse(this.props.location.search.slice(1))[this.props.blockName],
        qs.parse(prevProps.location.search.slice(1))[this.props.blockName]
      ) &&
      this.props.location.pathname === prevProps.location.pathname &&
      this.props.location.hash === prevProps.location.hash
    ) {
      console.log(
        qs.parse(this.props.location.search.slice(1))[this.props.blockName]
      );
      this.sendRequest();
    }
  }

  setQueryParams = queryParams => {
    this.state.queryParams = { ...this.state.queryParams, ...queryParams };
    this.props.changeQueryParams({
      ...this.state.queryParams,
      ...this.state.queryParamsStatic
    });
  };

  setGroupQueryParamsAndUpdateHistory = () => {
    this.props.setGroupQueryParamsAndUpdateHistory({
      [this.props.blockName]: this.state.queryParams
    });
  };

  sendRequest = () => {
    this.setQueryParams(
      qs.parse(this.props.location.search.slice(1))[this.props.blockName]
    );
    this.props.sendRequest();
  };

  render() {
    let items = null;
    if (this.props.itemsIds.length > 0) {
      items = (
        <React.Fragment>
          {this.props.itemsIds.map(itemId => (
            <UserDaysStatTable2Item item={this.props.selectItemById(itemId)} />
          ))}
        </React.Fragment>
      );
    } else {
      items = (
        <tr>
          <td className="text-center" colSpan="8">
            {t('Записи не найдены')} :-(
          </td>
        </tr>
      );
    }
    return (
      <div>
        {this.props.requestState.inProgress ? <OpacityPreLoader /> : null}
        <form className="form-inline">
          <GroupByTypesSelect
            className="form-group btn-group"
            startValue={this.state.queryParams.group_by}
            handleChangeValue={value => {
              this.setQueryParams({
                page: 1,
                group_by: value
              });
              this.setGroupQueryParamsAndUpdateHistory();
            }}
          />
          <DateRangeInput
            startValueFrom={this.state.queryParams.dateFrom}
            startValueTo={this.state.queryParams.dateTo}
            idElement={`${this.props.blockName}-dataRange`}
            handleChangeRangeValues={range => {
              this.setQueryParams({
                page: 1,
                dateFrom: range.valueFrom,
                dateTo: range.valueTo
              });
              this.setGroupQueryParamsAndUpdateHistory();
            }}
          />
          <div className="form-group">
            {t('За выбранный период')}:{' '}
            <span
              className="text-primary"
              data-original-title={t('Регистрации')}
              data-placement="top"
              data-referral="users"
              data-toggle="tooltip"
              title=""
            >
              <i className="fa fa-user" />{' '}
              <span className="val">{this.props.total.countReferral}</span>
            </span>
            ,{' '}
            <span
              className="text-success"
              data-original-title={t('Деньги')}
              data-placement="top"
              data-referral="money"
              data-toggle="tooltip"
              title=""
            >
              <i className="fa fa-rub" />{' '}
              <span className="val">{this.props.total.refSum}</span>
            </span>
          </div>
        </form>
        <div className="table-responsive">
          <table className="table table-sortible table-hover m-b-0">
            <thead>
              <tr>
                <SortLabelColumnToggle
                  label={t('Дата')}
                  tag="th"
                  defaultValue="date"
                  selectedValue={this.state.queryParams.sort}
                  handleChangeSortValue={sortValue => {
                    this.setQueryParams({
                      sort: sortValue
                    });
                    this.setGroupQueryParamsAndUpdateHistory();
                  }}
                />
                <SortLabelColumnToggle
                  label={t('Регистрации 1 ур.')}
                  tag="th"
                  defaultValue="ref_reg_counter"
                  className="text-right"
                  selectedValue={this.state.queryParams.sort}
                  handleChangeSortValue={sortValue => {
                    this.setQueryParams({
                      sort: sortValue
                    });
                    this.setGroupQueryParamsAndUpdateHistory();
                  }}
                />
                <SortLabelColumnToggle
                  label={t('Регистрации 2 ур.')}
                  tag="th"
                  defaultValue="ref_2_reg_counter"
                  className="text-right"
                  selectedValue={this.state.queryParams.sort}
                  handleChangeSortValue={sortValue => {
                    this.setQueryParams({
                      sort: sortValue
                    });
                    this.setGroupQueryParamsAndUpdateHistory();
                  }}
                />
                <SortLabelColumnToggle
                  label={`${t('Деньги')}, <i class="fa fa-rub" />`}
                  tag="th"
                  defaultValue="ref_sum"
                  className="text-right"
                  selectedValue={this.state.queryParams.sort}
                  handleChangeSortValue={sortValue => {
                    this.setQueryParams({
                      sort: sortValue
                    });
                    this.setGroupQueryParamsAndUpdateHistory();
                  }}
                />
              </tr>
            </thead>
            <tbody>{items}</tbody>
          </table>
        </div>
        <div className="table-footer">
          <PaginationBlock
            paginationData={this.props.pagination}
            handlePageClick={pageNumber => {
              this.setQueryParams({ page: pageNumber });
              this.setGroupQueryParamsAndUpdateHistory();
            }}
          />
        </div>
      </div>
    );
  }
}

UserDaysStatTable2.contextTypes = {
  router: PropTypes.shape()
};

UserDaysStatTable2.propTypes = {
  itemsIds: PropTypes.arrayOf(PropTypes.string).isRequired,

  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,
  selectItemById: PropTypes.func.isRequired,
  total: PropTypes.shape({
    countReferral: PropTypes.number,
    refSum: PropTypes.string
  }).isRequired,

  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired
  }).isRequired,

  pagination: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired,

  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
    hash: PropTypes.string.isRequired
  }).isRequired,

  // Component props
  blockName: PropTypes.string.isRequired,
  // eslint-disable-next-line react/require-default-props
  initQueryParams: PropTypes.shape({}),
  setGroupQueryParamsAndUpdateHistory: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  requestState: selectRequestState(state, userDaysStatListRN),
  pagination: selectPagination(state, userDaysStatListRN),
  itemsIds: selectItemsIds(state, userDaysStatListRN),
  selectItemById: id => selectItemById(state, userDaysStatListRN, id),
  total: selectTotal(state, userDaysStatListRN)
});

const mapDispatchToProps = dispatch => ({
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(userDaysStatListRN, queryParams)),
  sendRequest: () => dispatch(sendRequest(userDaysStatListRN))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UserDaysStatTable2)
);



// WEBPACK FOOTER //
// ./src/components/UserDaysStat/UserDaysStatTables/UserDaysStatTable2/UserDaysStatTable2.js